module.exports = __webpack_public_path__ + "static/How-to-Correct-a-Subluxation-d87b7cb8b08dae19fad53ede47f8c7dd.webp";